// extracted by mini-css-extract-plugin
module.exports = {"root":"_9fe083f4","block":"_ccb6464b","controlsBlock":"_d73d8e80","resetIcon":"_03a8742f"};